<ng-container [formGroup]="form">
    <div class="card p-4 mt-4">
        <div class="d-flex flex-column flex-sm-row justify-content-end align-items-stretch align-items-sm-center gap-2 pb-3 pick-medias-actions">
            <select *ngIf="mediaTag" class="form-select pick-medias-tag-select" formControlName="mediaTag">
                <option value="" disabled selected>{{ "Select a picture type" | translate }}</option>
                <option *ngFor="let t of mediaTags" [value]="t.value">{{ t.value | tagName }}</option>
            </select>
            <button
                class="btn btn-outline-primary text-nowrap"
                [disabled]="!isAddMediaButtonEnabled()"
                type="button"
                (click)="pickPhoto()"
            >
                <span class="ti ti-photo-plus"></span> {{ "Add photo" | translate }}
            </button>
        </div>
        <p *ngIf="!mediaTag && variantGroups.length === 0">
            {{ "offer_explanation_photos_no_variants" | translate }}
        </p>
        <p *ngIf="mediaTag">
            {{ "offer_explanation_photos_media_tag" | translate }}
        </p>
        <!-- Group offer "medias" -->
        <div *ngIf="variantGroups.length > 0; else noOfferGroupMedias" ngbAccordion [closeOthers]="true" [destroyOnHide]="true">
            <div *ngIf="submitted && variantGroups.length === 1 && variantGroups[0].medias.length < 2" class="text-danger mb-2">
                <i class="bi bi-exclamation-triangle-fill me-1"></i>
                <small>{{ "You must upload at least 2 photos." | translate }}</small>
            </div>
            <div
                ngbAccordionItem
                *ngFor="let offer of variantGroups; let i = index"
                [collapsed]="i !== 0"
                (show)="accordionItemToggled(offer.code, 'show')"
                (hide)="accordionItemToggled(offer.code, 'hide')"
            >
                <h1 *ngIf="variantGroups.length > 1" ngbAccordionHeader>
                    <button type="button" ngbAccordionButton [disabled]="uploadingImages.length > 0">
                        <span class="fw-bold pe-2">{{ offer.filter.displayName }}</span
                        >{{ offer.value.name }}
                        <span *ngIf="submitted && offer.medias.length < 2" class="text-danger ms-2">
                            <i class="bi bi-exclamation-triangle-fill me-1"></i>
                            <small>{{ "You must upload at least 2 photos." | translate }}</small>
                        </span>
                    </button>
                </h1>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <div class="py-4 text-center" *ngIf="offer.medias.length === 0 && uploadingImages.length === 0">
                                <em>{{ "No picture yet" | translate }}</em>
                            </div>
                            <div class="d-flex justify-content-start align-items-start flex-wrap gap-2">
                                <!-- Existing media items -->
                                <div *ngFor="let media of offer.medias" class="text-center pb-2">
                                    <div class="offer-media-container">
                                        <app-picture size="150" format="square" [picture]="media"></app-picture>
                                    </div>
                                    <div class="text-center fw-bold pt-2" *ngIf="media.tag">
                                        <span class="badge bg-secondary">{{ media.tag | tagName }}</span>
                                    </div>
                                    <button type="button" class="btn btn-danger btn-sm mt-2" (click)="removeMedia(media.id)">
                                        <i class="bi bi-trash"></i>&nbsp; {{ "Remove" | translate }}
                                    </button>
                                </div>
                                <!-- Upload placeholders -->
                                <div *ngFor="let upload of uploadingImages" class="text-center pb-2">
                                    <div class="offer-media-placeholder">
                                        <app-loader></app-loader>
                                    </div>
                                    <div class="text-center pt-2">
                                        <small class="text-muted">{{ upload.filename }}</small>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
        <!-- medias -->
        <ng-template #noOfferGroupMedias>
            <div *ngIf="submitted && form.get('medias').value.length < 2" class="text-danger mb-2">
                <i class="bi bi-exclamation-triangle-fill me-1"></i>
                <small>{{ "You must upload at least 2 photos." | translate }}</small>
            </div>
            <div class="py-4 text-center" *ngIf="form.get('medias').value.length === 0 && uploadingImages.length === 0">
                <em>{{ "No picture yet" | translate }}</em>
            </div>
            <div class="d-flex justify-content-start align-items-start flex-wrap gap-2">
                <!-- Existing media items -->
                <div *ngFor="let media of form.get('medias').value" class="text-center pb-2">
                    <div class="offer-media-container">
                        <app-picture size="150" format="square" [picture]="media"></app-picture>
                    </div>
                    <div class="text-center fw-bold pt-2" *ngIf="media?.tag">
                        <span class="badge bg-secondary">{{ media?.tag | tagName }}</span>
                    </div>
                    <button type="button" class="btn btn-danger btn-sm mt-2" (click)="removeMedia(media.id)">
                        <i class="bi bi-trash"></i>&nbsp; {{ "Remove" | translate }}
                    </button>
                </div>
                <!-- Upload placeholders -->
                <div *ngFor="let upload of uploadingImages" class="text-center pb-2">
                    <div class="offer-media-placeholder">
                        <app-loader></app-loader>
                    </div>
                    <div class="text-center pt-2">
                        <small class="text-muted">{{ upload.filename }}</small>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
    <div class="form-group d-flex justify-content-end pt-4">
        <button
            type="button"
            class="btn btn-lg btn-primary d-inline-flex align-items-center"
            [disabled]="uploadingImages.length > 0"
            (click)="submit()"
        >
            {{ "Next" | translate }} <span class="bi ps-2 bi-arrow-right"></span>
        </button>
    </div>
</ng-container>
